
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 730 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 500V0h466l127 128 127 129v743H10V500zm678 122l2-342H450V40H50v930l318-2 317-3 3-343z"}})])
          )
        }
      }
    